import React from "react";
import { Container } from "./styles";
import Card from "./Card";

const ListGrid = ({ wishlists, onDeleteWishlist, onUpdateWishlist, openModal, closeModal, addNotification }) => {
  return (
    <Container>
      {wishlists.map(({ id, name, articles_count, images }) => (
        <Card
          key={id}
          id={id}
          nameList={name}
          products={articles_count}
          images={images}
          onDeleteWishlist={onDeleteWishlist}
          onUpdateWishlist={onUpdateWishlist}
          openModal={openModal}
          closeModal={closeModal} 
          addNotification={addNotification}
        />
      ))}
    </Container>
  );
};

export default ListGrid;
